var axios = require('axios');
function ajaxCalls() {
    return {

        'report':function(global,message,callback) {
            var question = global.dermpaths[global.currentSlide];
            axios({
                method:'get',
                url: adminAjax ,
                params: {
                    action: 'feedback',
                    question_id : question.id,
                    message : message
                }
            }).then(function(response) {
                callback(response.data);
            });
        },
        'getSlides':function(callback) {
            axios({
                method:'get',
                url: apiUrl + 'slide_study/' ,
            }).then(function(response) {
                callback(response.data);
            });
        },
        'report_slide':function(slide_id,message,callback) {
            axios({
                method:'get',
                url: apiUrl+'slide_study/' + slide_id + '/feedback',
                params: {
                    user_id : userId,
                    message : message
                }
            }).then(function(response) {
                callback(response.data);
            })
        },
        'flashcard_report':function(global,message,callback) {
            var question = global.flashcards[global.currentSlide];
            axios({
                method:'get',
                url: apiUrl + 'practiceExam/' + question.id + '/feedback' ,
                params: {
                    user_id: userId,
                    action: 'feedback',
                    message : message
                }
            }).then(function(response) {
                callback(response.data);
            });
        },

    }
}

module.exports = new ajaxCalls;


//////////////////
// WEBPACK FOOTER
// ./src/ajaxCalls.js
// module id = 24
// module chunks = 0